<template>
    <div class="container-fluid">
        <b-card no-body class="my-2 card-transparent-background p-0">
            <b-card-header class="">
                <b-card-title class="card-title-page-garden-help-default my-0 p-0">Edit Job
                </b-card-title>
            </b-card-header>
        </b-card>
        <b-row class="mx-auto">
            <b-col class="px-0">
                <b-card no-body class="my-2">
                    <b-card-header class="">
                        <b-row cols-md="2" cols="1" class="">
                            <b-col lg="3">
                                <b-card-title class="card-title-page-garden-help-default my-1">Job No. {{ job_obj.order_id
                                }}
                                </b-card-title></b-col>
                            <b-col lg="9">
                                <b-row class="float-right">
                                    <b-col md="auto" sm="auto" v-if="job_obj.details"> <label
                                            class="job-details-date-garden-help  my-1">
                                            <img src="@/assets/images/garden-help/schedule-icon-active.png" />
                                            Booking date:
                                            <span id="booking_date">{{
                                                formatDateToDMonYear(job_obj.details.booking_date_no_tz)
                                            }}</span>
                                        </label></b-col>
                                    <b-col md="auto" sm="auto" class="status-span-container"><span
                                            :class="'jobStatusSpan ' + job_obj.status + '_status my-auto'">{{
                                                getJobStatusClassAndStr(job_obj.status) }}</span></b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-card-header>
                </b-card></b-col>
        </b-row>

        <b-form @submit.prevent="onSubmit" ref="addJobForm">
            <b-card no-body class="mt-4">
                <b-card-body class="px-2">
                    <b-row>
                        <b-col md="6" class="pr-md-0">
                            <PersonalData v-if="user_type != 'user'" :type="'view'" :view_select_customer="false"
                                :first_name.sync="job_obj.contact.first_name" :invalid_first_name="invalid_first_name"
                                :last_name.sync="job_obj.contact.last_name" :invalid_last_name="invalid_last_name"
                                :email.sync="job_obj.contact.email" :invalid_email="invalid_email"
                                :invalid_correct_email="invalid_correct_email" :phone_number.sync="job_obj.contact.phone"
                                :invalid_phone_number="invalid_phone_number" :contact_through.sync="contact_through"
                                :selected_customer_id.sync="selected_customer_id" :customer_list="customer_list"
                                :invalid_customer_id="invalid_customer_id" />

                            <PropertyDetails :type="'view'" :address.sync="job_obj.property.address"
                                :property_type.sync="job_obj.property.type" :property_size="job_obj.property.size"
                                :site_details.sync="job_obj.property.site_details"
                                :selected_property_images="job_obj.property.media" />

                            <ServiceDetails type="edit" :service.sync="job_obj.services" :service_options="service_options"
                                :invalid_service="invalid_service" :first_time_service.sync="first_time_service"
                                :last_service_date.sync="last_service_date"
                                :booking_date.sync="job_obj.details.booking_date_no_tz"
                                :invalid_booking_date="invalid_booking_date" :short_description.sync="job_obj.description"
                                :more_details.sync="more_details" :edit_booking_date="enable_edit_booking_date"
                                :edit_service="enable_edit_service" />
                            <!-- {{ service_options }}
                            <hr />
                            {{ service }}
                            <hr />
                            {{ services_obj }}
                            <hr />
                            {{ job_obj.services }} -->


                        </b-col>
                        <b-col md="6">
                            <b-card no-body class="card-transparent-background h-100 my-0">
                                <!-- <b-card-header class="card-title-garden-help-default pb-0 pl-1">Select Location on
                                    Map</b-card-header> -->
                                <b-card-body class="h-100 pt-1 px-1">
                                    <GmapMap :center="map_center" :zoom="map_zoom" map-type-id="hybrid"
                                        class="job-map-container-garden-help h-100" ref="gmap">
                                        <GmapMarker v-if="job_obj.job_position != null" :position="job_obj.job_position"
                                            :clickable="false" :draggable="false" />
                                        <gmap-polygon
                                            v-if="job_obj != null && job_obj.property != null && job_obj.property.map_points != null"
                                            :paths="job_obj.property.map_points.points" ref="polygon"
                                            :options="polyogn_options" :editable="false">
                                        </gmap-polygon>
                                    </GmapMap>

                                </b-card-body>
                            </b-card>
                        </b-col>
                    </b-row>

                </b-card-body>
            </b-card>
            <b-row class="justify-content-center justify-content-lg-right mt-3 mx-auto">
                <b-col xl="2" lg="3" sm="4" class="px-md-1 text-center">
                    <b-button v-if="!is_loading" type="submit" variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100">Save Job</b-button>


                    <b-button v-else type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100">
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
            </b-row>


        </b-form>
    </div>
</template>
<script>
import $ from "jquery";
import moment from 'moment'
import axios from "axios";
// import { gmapApi } from "vue2-google-maps";
import PersonalData from "../customer/details_components/PersonalData.vue";
import PropertyDetails from "../customer/details_components/PropertyDetails.vue";
import ServiceDetails from "./details_components/ServiceDetails.vue";

import { uploadFiles } from "@/utils/upload-files.js";
import SelectPayment from "../components/SelectPayment.vue"
import InputRadio from "@/components/Inputs/InputRadio.vue";

import { getJobStatusClassAndStr } from "@/utils/helper-functions-garden-help.js"
import { formatDateToDMonYear } from "@/utils/helper-functions.js"


export default {
    name: "GardenHelpEditJob",
    components: {
        PersonalData, PropertyDetails, ServiceDetails,
        SelectPayment, InputRadio
    },
    data() {
        return {
            client_name: "GARDENHELP",
            user_type: null,
            user_id: null,

            job_id: null,
            job_obj: {
                booking_date: "",

                customer_name: "",
                customer_email: "",
                customer_phone: "",

                location: "",
                property_type: "",

                services: [],
                short_description:
                    "",

                property_size: "",
                last_service: "",
                first_service: "",
                site_details: "",

                address: "",
                job_position: {},
                paths: [],
                property_images: [],

                status: "",
            },

            map_zoom: 18,
            map_center: { lat: 53.364379779866695, lng: -6.8271807338634555 },

            polyogn_options: {
                fillColor: "#0068B8",
                fillOpacity: 0.5,
                strokeColor: "#0068B8",
                strokeWeight: 3,
                editable: false,
            },
            job_position: null,
            edited: null,
            polygon: null,
            polygon_points: null,
            drawingManager: null,
            invalid_property_size: false,

            //////////////// personal data
            perosnal_data_type: "add",
            first_name: "",
            invalid_first_name: false,
            last_name: "",
            invalid_last_name: false,
            email: "",
            invalid_email: false,
            invalid_correct_email: false,
            phone_number: "",
            invalid_phone_number: false,
            contact_through: null,
            selected_customer_id: 'new',
            customer_list: [],
            invalid_customer_id: false,
            ///////// property details
            property_data_type: "add",
            address: null,
            longitude: null,
            latitude: null,
            invalid_address: false,
            invalid_address_longitude: false,
            invalid_address_latitude: false,
            property_type: null,
            invalid_property_type: false,
            property_size: null,
            site_details: null,
            property_images: [],
            property_images_ids: [],
            invalid_images: false,
            selected_property_id: 'new',
            invalid_property_id: false,
            property_list: [],
            selected_property_images: [],
            //////// service details
            service: [],
            services_obj: [],
            service_options: [],
            invalid_service: false,
            first_time_service: null,
            last_service_date: null,
            booking_date: null,
            invalid_booking_date: false,
            short_description: null,
            more_details: null,


            cards_list: [
                { title: "New card", value: "new" }
            ],
            payment_method_id: null,
            invalid_payment_method: false,
            // paths: [
            //   [
            //     { lat: 1.38, lng: 103.8 },
            //     { lat: 1.38, lng: 103.81 },
            //     { lat: 1.39, lng: 103.81 },
            //     { lat: 1.39, lng: 103.8 },
            //   ],
            //   [
            //     { lat: 1.382, lng: 103.802 },
            //     { lat: 1.382, lng: 103.808 },
            //     { lat: 1.388, lng: 103.808 },
            //     { lat: 1.388, lng: 103.802 },
            //   ],
            // ],
            is_loading: false,
            user_type: localStorage.getItem('user_type'),

            find_contractor_id: null,
            job_id: null,


            yes_no_options: [
                { label: "Yes", value: 1 },
                { label: "No", value: 0 },
            ],
            send_cutomer_email: null,

            enable_edit_booking_date: false,
            enable_edit_service: false,
            is_edited_service: false

        };
    },
    mounted() {

        let user = JSON.parse(window.localStorage.getItem("user"));
        this.user_type = window.localStorage.getItem("user_type")
        this.user_id = user.id
        //
        this.getServicesList()

        this.user_type = localStorage.getItem('user_type')

        this.job_id = Number(this.$route.params.id);

        let status_param = this.$route.params.status
        if (status_param == 'history') {
            this.job_obj.status = 'complete'
        } else if (status_param == 'offers') {
            this.has_offers = true
        } else if (status_param == 'requests') {
            this.job_obj.status = 'pending'
        }
        console.log(this.$route.params.status)
        this.getJobDetails()

    },
    watch: {

        'job_obj.services': function (newVal, oldVal) {
            console.log("Ssssssssssssss")
            console.log(newVal)
            console.log(oldVal)
            if (oldVal.length != 0 && newVal.length > 0) {
                this.is_edited_service = true
            }
            //to work with changes in someOtherProp
        },
        // job_obj: {
        //     handler(val) {
        //         // do stuff
        //     },
        //     deep: true
        // }
    },
    computed: {
        formated_date() {
            return moment(this.job_obj.details.booking_date_no_tz).format("YYYY-MM-DD HH:mm")
        }
    },
    methods: {
        getJobStatusClassAndStr,
        uploadFiles,
        formatDateToDMonYear,

        getServicesList() {
            axios
                .get("/services/list", {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.service_options = response.data;
                    console.log(Object.keys(this.$route.query).length)
                    if (Object.keys(this.$route.query).length != 0) {
                        let selected_services = this.$route.query.services.split(',')
                        this.service = []
                        for (let i = 0; i < selected_services.length; i++) {
                            this.service.push(Number(selected_services[i]))
                        }
                    }
                });
        },

        checkValidation() {

            if (this.job_obj.services == null || this.job_obj.services.length == 0) {
                this.invalid_service = true
            } else {
                this.invalid_service = false
            }
            if (this.job_obj.details.booking_date_no_tz == null || this.job_obj.details.booking_date_no_tz == '') {
                this.invalid_booking_date = true
            } else {
                this.invalid_booking_date = false
            }

        },
        async onSubmit() {
            console.log("on submit edit job", this.user_type, this.user_id)
            console.log(this.$refs)

            console.log("service:", this.job_obj.services)
            console.log(this.job_obj.details.booking_date_no_tz)

            this.is_loading = true
            this.checkValidation()

            if (!this.invalid_service && !this.invalid_booking_date) {

                let requestData = {
                    client: this.client_name,

                    "order_details": {
                        "service_types": this.job_obj.services.toString(),
                        "booking_date": this.job_obj.details.booking_date_no_tz
                    }
                };


                this.sendEditJobRequest(requestData)
            } else {
                this.is_loading = false
            }
        },
        sendEditJobRequest(requestData) {

            console.log(requestData)
            axios
                .post("/jobs/job-action/" + this.job_id, requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$fire({
                        // title: "Title",
                        text: "Job is updated successfully ",
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        console.log(this.is_edited_service);
                        this.is_loading = false;
                        if (this.is_edited_service) {
                            // alert(this.job_id)
                            if (this.job_obj.the_invoice) {
                                console.log('quote id', this.job_obj.the_invoice.id)
                                this.$router.push({ name: "GardenHelpEditQuoteIndex", params: { id: this.job_obj.the_invoice.id } });
                            } else {
                                // this.$router.go(-1);
                                this.$router.push({ name: "GardenHelpJobsDetails", params: { id: this.job_id } });
                            }

                        } else {
                            // this.$router.go(-1);
                            this.$router.push({ name: "GardenHelpJobsDetails", params: { id: this.job_id } });
                        }
                    });


                })
                .catch((error) => {
                    console.log(error.response);
                    this.is_loading = false;
                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                    });
                });
        },

        getJobDetails() {
            this.show_overlay = true
            axios
                .get("/jobs/jobs/" + this.job_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)

                    this.job_obj = response.data

                    console.log(this.job_obj.location_lat, Number(this.job_obj.location_lat))
                    this.map_center = { lat: Number(this.job_obj.location_lat), lng: Number(this.job_obj.location_lang) }
                    this.job_obj.job_position = { lat: Number(this.job_obj.location_lat), lng: Number(this.job_obj.location_lang) }
                    this.payment_method_id = this.job_obj.payment_method_id

                   this.job_obj.details.booking_date_no_tz = moment(this.job_obj.details.booking_date_no_tz).format("YYYY-MM-DD HH:mm")

                    this.enable_edit_booking_date = this.job_obj.status != 'in_progress' && this.job_obj.status != 'complete'
                    this.enable_edit_service = this.job_obj.status != 'complete'

                    this.job_obj.services = this.job_obj.orig_services.map((obj) => obj.id)

                    this.show_overlay = false
                });
        },
    },
};
</script>
  
<style >
.gmnoprint div button {
    margin-right: 4px !important;
    border-radius: 3px !important;
}
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/EditJob.vue